import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface ViewsState {
  isReadOnly: boolean;
}

export const initialState: ViewsState = {
  isReadOnly: false,
};

export const getInternalDocument = createAction<GetInternalDocumentPayload>(
  'views/getInternalDocument',
);

export const getPublicInternalDocument =
  createAction<GetPublicInternalDocumentPayload>(
    'views/getPublicInternalDocument',
  );

const slice = createSlice({
  initialState,
  name: 'views',
  reducers: {
    setIsReadOnly: (state, { payload }: PayloadAction<boolean>) => {
      state.isReadOnly = payload;
    },
  },
});

export const getViewsState = (state: RootState): ViewsState =>
  state[slice.name];

export const { reducer: viewsReducer } = slice;
export const { setIsReadOnly } = slice.actions;
